// Using Object Literal as Singleton Pattern
const Application: Models.Application = {
	url: null,
	locale: null,
	setUrl(url): URL {
		this.url = new URL(url);
		return this.url;
	},

	setLocale(tag, options): Intl.Locale {
		this.locale = new Intl.Locale(tag, options);
		return this.locale;
	},
};

export default Application;
